var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoubleGauche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 27.470703 2.9863281 A 1.50015 1.50015 0 0 0 26.439453 3.4394531 L 6.9394531 22.939453 A 1.50015 1.50015 0 0 0 6.9394531 25.060547 L 26.439453 44.560547 A 1.50015 1.50015 0 1 0 28.560547 42.439453 L 10.121094 24 L 28.560547 5.5605469 A 1.50015 1.50015 0 0 0 27.470703 2.9863281 z M 39.470703 2.9863281 A 1.50015 1.50015 0 0 0 38.439453 3.4394531 L 18.939453 22.939453 A 1.50015 1.50015 0 0 0 18.939453 25.060547 L 38.439453 44.560547 A 1.50015 1.50015 0 1 0 40.560547 42.439453 L 22.121094 24 L 40.560547 5.5605469 A 1.50015 1.50015 0 0 0 39.470703 2.9863281 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoubleGauche);
export default __webpack_public_path__ + "static/media/icons8-double-gauche.58582de42392d6a97611a04de7a76ef3.svg";
export { ForwardRef as ReactComponent };